// Runtime instance config — lets ONE prebuilt SPA bundle serve every
// instance. The instance's web server serves /env.js (written at provision
// time) which sets window.__KIT_ENV__ with the per-instance values that used
// to be baked in at build time (public URL, anon key, upload API). Build-time
// REACT_APP_* vars remain as fallbacks so dev servers and single-instance
// builds work unchanged.
const runtime = (typeof window !== 'undefined' && window.__KIT_ENV__) || {};

export const kitEnv = (key, fallback = '') => {
  const v = runtime[key];
  return v === undefined || v === null || v === '' ? fallback : v;
};

// The instance's display name: runtime env.js (`APP_NAME`, written at
// provision time), else the build-time REACT_APP_APP_NAME, else 'starter'.
// One source for the navbar, login card, drop page and document title.
export const APP_NAME = kitEnv('APP_NAME', process.env.REACT_APP_APP_NAME || 'starter');

// Site mode: the control plane stopped this instance's stack and serves a
// static snapshot of the public site from the host edge (env.js rewritten
// with SITE_MODE: 'static', the site row at /site.json). No API, no auth, no
// realtime — the bundle must not dial any of them.
export const SITE_MODE = kitEnv('SITE_MODE') === 'static';
